import React from 'react';

import { useTranslations } from '@lang';
import { Discount, Price as PriceTypes } from 'shared-types/Common';
import { DiscountPrice } from '../../../components/Price';
import { Button } from '../../../components/Button';

import { OptionsButtonWrapper, PriceWrapper, GlobalStyle } from './OptionsButton.styles';

export type OptionsButtonProps = {
  id: string;
  isSingleOption: boolean | null;
  onFormSubmit: any;
  price: PriceTypes;
  discount?: Discount;
};

export const OptionsButton: React.FC<OptionsButtonProps> = ({
  id,
  isSingleOption,
  onFormSubmit,
  price,
  discount,
}) => {
  const { t } = useTranslations();
  const scrollToOptions = () => {
    const href = `#${id}`;
    const element = document.querySelector(href);

    if (element instanceof HTMLElement) {
      window.scrollTo({
        top: element.offsetTop,
        behavior: 'smooth',
      });
    }
  };

  const onButtonClick = () => (isSingleOption ? onFormSubmit() : scrollToOptions());

  const ButtonMessage = t(isSingleOption ? 'product.ctaButton' : 'product.mobileCtaButton');

  return (
    <>
      <GlobalStyle />
      <OptionsButtonWrapper>
        <PriceWrapper>
          <DiscountPrice price={price} discount={discount} />
        </PriceWrapper>
        <Button isPrimary onClick={onButtonClick}>
          {ButtonMessage}
        </Button>
      </OptionsButtonWrapper>
    </>
  );
};
